/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        var wow = new WOW(
          {
            boxClass:     'wow',     
            animateClass: 'animated', 
            offset:       0,          
            mobile:       true,       
            live:         true,       
            scrollContainer: null 
          }
        );
        wow.init();


        $(".singlePost .content-area img").wrap(function() {
            return '<a data-fancybox="gallery" class="fancybox" href="' + $(this).attr("src") + '"/>';
        });

        $( ".singlePost .content-area p > a.fancybox" ).append( "<div class='plus'></div>" );
        $( ".singlePost .content-area figure > a.fancybox" ).append( "<div class='plus'></div>" );

        $('.owl-carousel').owlCarousel({
            loop:true,
            margin:10,
            responsiveClass:true,
            nav: true,
            dots: false,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1
                },
                1000:{
                    items:1
                }
            }
        }); 

        $('.eheights').matchHeight(); 

        $('.read-more a.close').click(function() {
          $('.read-more').css('display','none');
        });

         $('a[href="#search"]').on('click', function(event) {
              event.preventDefault();
              $('#search').addClass('open');
              $('#search > form > input[type="search"]').focus();
          });
          
          $('#search, #search button.close').on('click keyup', function(event) {
              if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                  $(this).removeClass('open');
              }
          });

          var elSelector    = '.header',
              elClassHidden = 'header--hidden',
              throttleTimeout = 500,
              $element    = $( elSelector );

            if( !$element.length ) return true;

            var $window     = $( window ),
              wHeight     = 0,
              wScrollCurrent  = 0,
              wScrollBefore = 0,
              wScrollDiff   = 0,
              $document   = $( document ),
              dHeight     = 0,

              throttle = function( delay, fn )
              {
                var last, deferTimer;
                return function()
                {
                  var context = this; 
                  var args = arguments;
                  var now = +new Date;
                  if( last && now < last + delay )
                  {
                    clearTimeout( deferTimer );
                    deferTimer = setTimeout( function(){ last = now; fn.apply( context, args ); }, delay );
                  }
                  else
                  {
                    last = now;
                    fn.apply( context, args );
                  }
                };
              }; 
               $window.on( 'scroll', throttle( throttleTimeout, function()
            {
              dHeight     = $document.height();
              wHeight     = $window.height();
              wScrollCurrent  = $window.scrollTop();
              wScrollDiff   = wScrollBefore - wScrollCurrent;

              if( wScrollCurrent <= 0 ) // scrolled to the very top; element sticks to the top
                $element.removeClass( elClassHidden );

              else if( wScrollDiff > 0 && $element.hasClass( elClassHidden ) ) // scrolled up; element slides in
                $element.removeClass( elClassHidden );

              else if( wScrollDiff < 0 ) // scrolled down
              {
                if( wScrollCurrent + wHeight >= dHeight && $element.hasClass( elClassHidden ) ) // scrolled to the very bottom; element slides in
                  $element.removeClass( elClassHidden );

                else // scrolled down; element slides out
                  $element.addClass( elClassHidden );
              }

              wScrollBefore = wScrollCurrent;
            }));
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'single': {
      init: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      } 
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
